var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNurse({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#ED9082",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1485 8.41562L1.75 5.61374L1.95321 5.39195C3.5994 3.59525 5.31104 2.625 7.086 2.625C8.86095 2.625 10.5726 3.59525 12.2188 5.39195L12.422 5.61374L11.0189 8.4248V10.5H3.1485V8.41562ZM3.8566 7.875L2.80315 5.76443C4.2899 4.21291 5.71689 3.5 7.086 3.5C8.4551 3.5 9.88209 4.2129 11.3688 5.76443L10.3154 7.875H3.8566ZM4.0235 9.625V8.75H10.1439V9.625H4.0235Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6485 6.125V6.99771H7.5235V6.125H8.3962V5.25H7.5235V4.37729H6.6485V5.25H5.77579V6.125H6.6485Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNurse);
export default __webpack_public_path__ + "static/media/icon-nurse.6c5221db8f72e2ebbe176a705787287a.svg";
export { ForwardRef as ReactComponent };